export const AG_GRID_LOCALE_NBNO = {
  // Set Filter
  selectAll: '(Velg Alle)',
  selectAllSearchResults: '(Velg Alle Søkeresultater)',
  searchOoo: 'Søk...',
  blanks: '(Tomme)',
  noMatches: 'Ingen treff',

  // Number Filter & Text Filter
  filterOoo: 'Filter...',
  equals: 'Er lik',
  notEqual: 'Er ulik',
  empty: 'Velg En',

  // Number Filter
  lessThan: 'Mindre enn',
  greaterThan: 'Større enn',
  lessThanOrEqual: 'Mindre enn eller lik',
  greaterThanOrEqual: 'Større enn eller lik',
  inRange: 'Innen rekkevidde',
  inRangeStart: 'fra',
  inRangeEnd: 'til',

  // Text Filter
  contains: 'Inneholder',
  notContains: 'Inneholder ikke',
  startsWith: 'Starter med',
  endsWith: 'Slutter med',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: 'OG',
  orCondition: 'ELLER',

  // Filter Buttons
  applyFilter: 'Bruk',
  resetFilter: 'Nullstill',
  clearFilter: 'Fjern',
  cancelFilter: 'Avbryt',

  // Filter Titles
  textFilter: 'Tekst Filter',
  numberFilter: 'Nummer Filter',
  dateFilter: 'Dato Filter',
  setFilter: 'Sett Filter',

  // Side Bar
  columns: 'Kolonner',
  filters: 'Filtere',

  // columns tool panel
  pivotMode: 'Pivot Modus',
  groups: 'Radgrupper',
  rowGroupColumnsEmptyMessage: 'Dra hit for å sette radgrupper',
  values: 'Verdier',
  valueColumnsEmptyMessage: 'Dra hit for å samle',
  pivots: 'Kolonneetiketter',
  pivotColumnsEmptyMessage: 'Dra hit for å sette kolonneetiketter',

  // Header of the Default Group Column
  group: 'Gruppe',

  // Other
  loadingOoo: 'Laster...',
  noRowsToShow: 'Fant ingen rader',
  enabled: 'Aktivert',

  // Menu
  pinColumn: 'Fest Kolonne',
  pinLeft: 'Fest til Venstre',
  pinRight: 'Fest til Høyre',
  noPin: 'Ikke Fest',
  valueAggregation: 'Samling av Verdier',
  autosizeThiscolumn: 'Auto størrelse på denne Kolonnen',
  autosizeAllColumns: 'Auto størrelse på alle Kolonner',
  groupBy: 'Gruppèr etter',
  ungroupBy: 'Avgruppèr etter',
  resetColumns: 'Nullstill Kolonner',
  expandAll: 'Utvid Alle',
  collapseAll: 'Lukk Alle',
  copy: 'Kopier',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'Kopier med Overskrifter',
  paste: 'Lim inn',
  ctrlV: 'Ctrl+V',
  export: 'Eksporter',
  csvExport: 'CSV Eksport',
  excelExport: 'Excel Eksport',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Sum',
  min: 'Min',
  max: 'Max',
  none: 'Ingen',
  count: 'Opptelling',
  avg: 'Gjennomsnitt',
  filteredRows: 'Filtrerte',
  selectedRows: 'Valgte',
  totalRows: 'Totalt antall Rader',
  totalAndFilteredRows: 'Rader',
  more: 'Flere',
  to: 'Til',
  of: 'Fra',
  page: 'Side',
  nextPage: 'Neste Side',
  lastPage: 'Siste Side',
  firstPage: 'Første Side',
  previousPage: 'Forrige Side',

  // Pivoting
  pivotColumnGroupTotals: 'Totalt',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Diagram & Pivot Modus',
  pivotChart: 'Pivot Diagram',
  chartRange: 'Diagramområde',

  columnChart: 'Kolonne',
  groupedColumn: 'Gruppert',
  stackedColumn: 'Stablet Diagram',
  normalizedColumn: '100% Stablet',

  barChart: 'Stolpe',
  groupedBar: 'Gruppert',
  stackedBar: 'Stablet',
  normalizedBar: '100% Stablet',

  pieChart: 'Sektor',
  pie: 'Sektor',
  doughnut: 'Hjul',

  line: 'Linje',

  xyChart: 'X Y (Spredning)',
  scatter: 'Spredning',
  bubble: 'Boble',

  areaChart: 'Område',
  area: 'Område',
  stackedArea: 'Stablet',
  normalizedArea: '100% Stablet',

  histogramChart: 'Histogram',

  // Charts
  pivotChartTitle: 'Pivot Diagram',
  rangeChartTitle: 'Område Diagram',
  settings: 'Innstillinger',
  data: 'Data',
  format: 'Format',
  categories: 'Kategorier',
  defaultCategory: '(Ingen)',
  series: 'Serie',
  xyValues: 'X Y Verdier',
  paired: 'Parret Modus',
  axis: 'Akse',
  navigator: 'Navigatør',
  color: 'Farge',
  thickness: 'Tykkelse',
  xType: 'X Type',
  automatic: 'Automatisk',
  category: 'Kategori',
  number: 'Nummer',
  time: 'Tid',
  xRotation: 'X Rotasjon',
  yRotation: 'Y Rotasjon',
  ticks: 'Ticks',
  width: 'Bredde',
  height: 'Høyde',
  length: 'Lengde',
  padding: 'Padding',
  spacing: 'Mellomrom',
  chart: 'Diagram',
  title: 'Tittel',
  titlePlaceholder: 'Diagram tittel - dobbeltklikk for å endre',
  background: 'Bakgrunn',
  font: 'Font',
  top: 'Topp',
  right: 'Høyre',
  bottom: 'Bunn',
  left: 'Venstre',
  labels: 'Etiketter',
  size: 'Størrelse',
  minSize: 'Minimum Størrelse',
  maxSize: 'Maksimum Størrelse',
  legend: 'Forklaring',
  position: 'Posisjon',
  markerSize: 'Markør Størrelse',
  markerStroke: 'Markør Strøk',
  markerPadding: 'Markør Padding',
  itemSpacing: 'Element Mellomrom',
  itemPaddingX: 'Element Padding X',
  itemPaddingY: 'Element Padding Y',
  layoutHorizontalSpacing: 'Horisontalt Mellomrom',
  layoutVerticalSpacing: 'Vertikalt Mellomrom',
  strokeWidth: 'Strøk Bredde',
  offset: 'Forskyvning',
  offsets: 'Forskyvninger',
  tooltips: 'Tooltips',
  callout: 'Forklaring',
  markers: 'Markører',
  shadow: 'Skygge',
  blur: 'Uklarhet',
  xOffset: 'X Forskyvning',
  yOffset: 'Y Forskyvning',
  lineWidth: 'Linje Bredde',
  normal: 'Normal',
  bold: 'Fet',
  italic: 'Kursiv',
  boldItalic: 'Fet Kursiv',
  predefined: 'Forhåndsdefinert',
  fillOpacity: 'Fyll Opasitet',
  strokeOpacity: 'Linje Opasitet',
  histogramBinCount: 'Antall beholderer',
  columnGroup: 'Kolonne',
  barGroup: 'Stolpe',
  pieGroup: 'Sektor',
  lineGroup: 'Linje',
  scatterGroup: 'X Y (Spredning)',
  areaGroup: 'Område',
  histogramGroup: 'Histogram',
  groupedColumnTooltip: 'Gruppert',
  stackedColumnTooltip: 'Stablet',
  normalizedColumnTooltip: '100% Stablet',
  groupedBarTooltip: 'Gruppert',
  stackedBarTooltip: 'Stablet',
  normalizedBarTooltip: '100% Stablet',
  pieTooltip: 'Sektor',
  doughnutTooltip: 'Hjul',
  lineTooltip: 'Linje',
  groupedAreaTooltip: 'Område',
  stackedAreaTooltip: 'Stablet',
  normalizedAreaTooltip: '100% Stablet',
  scatterTooltip: 'Spredning',
  bubbleTooltip: 'Boble',
  histogramTooltip: 'Histogram',
  noDataToChart: 'Ingen tilgjengelig data for diagram.',
  pivotChartRequiresPivotMode:
    'Pivot Diagram krever at Pivot Modus er aktivert.',
  chartSettingsToolbarTooltip: 'Meny',
  chartLinkToolbarTooltip: 'Koblet til rutenett',
  chartUnlinkToolbarTooltip: 'Avkoblet fra rutenett',
  chartDownloadToolbarTooltip: 'Last ned Diagram',

  // ARIA
  ariaHidden: 'skjult',
  ariaVisible: 'synlig',
  ariaChecked: 'avkrysset',
  ariaUnchecked: 'uavkrysset',
  ariaIndeterminate: 'ubestemt',
  ariaColumnSelectAll: 'Aktiver merking av alle kolonner',
  ariaInputEditor: 'Input redigering',
  ariaDateFilterInput: 'Dato Filter Input',
  ariaFilterInput: 'Filter Input',
  ariaFilterColumnsInput: 'Filter Kolonner Input',
  ariaFilterValue: 'Filter Verdie',
  ariaFilterFromValue: 'Filter fra verdi',
  ariaFilterToValue: 'Filter til verdi',
  ariaFilteringOperator: 'Filtreringsoperatør',
  ariaColumn: 'Kolonne',
  ariaColumnGroup: 'Kolonnegruppe',
  ariaRowSelect: 'Tast MELLOMROM for å velge denne raden',
  ariaRowDeselect: 'Tast MELLOMROM for å fjerne denne raden',
  ariaRowToggleSelection: 'Tast MELLOMROM for å aktivere radseleksjon',
  ariaRowSelectAll: 'Tast MELLOMROM for å aktivere valg av alle rader',
  ariaToggleVisibility: 'Tast MELLOMROM for å aktivere synlighet',
  ariaSearch: 'Søk',
  ariaSearchFilterValues: 'Søkefilter verdier',

  // ARIA LABEL FOR DIALOGS
  ariaLabelColumnMenu: 'Kolonnemeny',
  ariaLabelCellEditor: 'Celle redigering',
  ariaLabelDialog: 'Dialog',
  ariaLabelSelectField: 'Velg Felt',
  ariaLabelTooltip: 'Tooltip',
  ariaLabelContextMenu: 'Kontekstmeny',
  ariaLabelColumnMenu: 'Kolonnemeny',
  ariaLabelSubMenu: 'Undermeny',
  ariaLabelAggregationFunction: 'Samlingsfunksjon',
};
